export class UploadVideoChunkResponseModel {
  /**Чанк был успешно загружен */
  ChunkIsSuccess: boolean = false;
  /**Видео было успешно загружено */
  VideoIsSuccess: boolean = false;
  /**ID видео */
  VideoId!: string;

  constructor(obj?: Partial<UploadVideoChunkResponseModel>) {
    Object.assign(this, obj);
  }
}
